import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from 'app/services/auth.service';
import { UserRepository } from 'app/services/database/user.repository';
import { PresentationService } from 'app/services/presentation/presentation.service';
import { Logger } from 'app/shared/logger';
import { LoggerFactory } from 'app/shared/loggerFactory';
import { DeviceModel } from 'app/views/devices/models/device.model';
import { ScheduleModel } from 'app/views/devices/models/schedule.model';
import { PresentationModel } from 'app/views/presentations/models/presentation.model';

@Component({
    selector: 'psm-schedule-editor',
    templateUrl: 'editSchedule.component.html',
    styleUrls: ['editSchedule.component.scss']
})

export class EditScheduleComponent implements OnInit {

    @Input()
    public schedule: ScheduleModel;

    @Output()
    public scheduleChange = new EventEmitter<ScheduleModel>();

    public defaultPresentation: PresentationModel;
    public presentations: PresentationModel[] = [];
    private presentationDictionary: {};

    public thumbnailPath: string;
    public isShowingAdvanced: boolean = false;
    public isLoading: boolean = true;
    private logger: Logger;

    constructor(
        private loggerFactory: LoggerFactory,
        private presentationService: PresentationService,
        private authService: AuthService,
        private userRepository: UserRepository
    ) {
        this.logger = loggerFactory.create('EditScheduleComponent');
    }

    public async ngOnInit() {
        this.isLoading = true;
        let user = await this.authService.getCurrentUser();
        this.presentations = await this.presentationService.getUserPresentationList(user.uid);

        this.presentationDictionary = {};
        for (let pres of this.presentations) {
            this.presentationDictionary[pres.id] = pres;
        }

        this.defaultPresentation = this.schedule.defaultPresentationId
                                   ? await this.presentationService.getPresentation(this.schedule.defaultPresentationId)
                                   : undefined;

        this.isShowingAdvanced = this.schedule.entries.length !== 0 && !this.schedule.scheduleIsDisabled;

        this.thumbnailPath = await this.presentationService.getThumbnailUrl(this.defaultPresentation);
        this.isLoading = false;
    }

    public onToggledAdvanceMode(value: boolean) {
        this.schedule.scheduleIsDisabled = !value;
        this.emitChange();
    }

    public async updateSelectedPresentation(id: string) {
        this.defaultPresentation = this.presentationDictionary[id];
        this.thumbnailPath = await this.presentationService.getThumbnailUrl(this.defaultPresentation);
        this.emitChange();
    }

    public emitChange() {
        this.scheduleChange.emit(this.schedule);
    }
}


// WEBPACK FOOTER //
// ./src/app/views/devices/editSchedule/editSchedule.component.ts